<p>list-job-details works!</p>
